import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  Input,
  FormFeedback,
  UncontrolledTooltip,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory, Link, useParams } from "react-router-dom";

// Backend
import { getCheckDetail } from "connection/backend";

// actions
import { checkUpdate } from "store/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

const CheckUpdate = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const redirect = () => {
    history.push("/checks");
  };

  const getData = async (id) => {
    const response = await getCheckDetail(id);
    const data = response.data;
    let state_front = "";
    if (data.state === "en_canje") {
      state_front = "En canje";
    } else if (data.state === "rechazado") {
      state_front = "Rechazado";
    } else {
      state_front = "Aprobado";
    }
    setFormData({
      client: data.client.code,
      full_name: data.client.full_name,
      actual_state: state_front,
      value: data.value.toLocaleString("es-CO"),
    });
  };

  useEffect(() => {
    getData(id);
  }, [id]);

  const [formData, setFormData] = useState({
    client: "",
    full_name: "",
    actual_state: "",
    value: "",
  });

  const { client, full_name, actual_state, value } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value.toUpperCase() });
  };

  const [state, setState] = useState("aprobado");

  const onChange1 = (e) => {
    setState(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(checkUpdate(id, { state: state }));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Cheques </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Cheques"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              {props.checkUpdated.id ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  El estado del cheque se ha actualizado correctamente.
                </SweetAlert>
              ) : null}
              <Card
                style={{
                  width: "70rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">Actualizar cheque</h2>
                </CardTitle>
                <CardBody>
                  <Form>
                    <Row className="justify-content-md-center">
                      <Col lg={6}>
                        <p>Información del cheque</p>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={2}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-id-card bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Código"
                              name="client"
                              id="client"
                              value={client}
                              onChange={onChange}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="client">Código</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-id-card bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Nombre completo"
                              name="full_name"
                              id="full_name"
                              value={full_name}
                              onChange={onChange}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="full_name">Nombre completo</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={3}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx bx-pulse bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Estado actual"
                              name="actual_state"
                              id="actual_state"
                              value={actual_state}
                              onChange={onChange}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="driver">Estado actual</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-dollar bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Valor"
                              name="value"
                              id="value"
                              value={value}
                              onChange={onChange}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="driver">Valor</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-center">
                      <Col lg={3}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-pulse bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="select"
                              className="form-control"
                              placeholder="Estado"
                              name="state"
                              id="state"
                              value={state}
                              onChange={onChange1}
                              required
                            >
                              <option value="aprobado">Aprobado</option>
                              <option value="rechazado">Rechazado</option>
                            </Input>
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="state">Estado</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-4 ms-5">
                      <Col lg={3}>
                        <Link className="btn btn-danger me-4" to="/checks">
                          Cancelar
                        </Link>

                        <Button color="success" type="submit">
                          Actualizar
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, checkUpdated } = state.Payment;
  return { error, loading, checkUpdated };
};

export default withRouter(connect(mapStateToProps)(CheckUpdate));
